"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.HeaderArea = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

require("antd/lib/menu/style");

var _menu = _interopRequireDefault(require("antd/lib/menu"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _client = require("../../../html/client");

require("antd/lib/grid/style");

var _Core = require("../../../components/Core");

var _styled = require("../../../styles/styled");

var _Link = require("../../../react-static/components/Link");

var _class;

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 80px;\n    font-size: 18px;\n    word-wrap: break-word;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SubMenu = _menu.default.SubMenu;

var SiteTitle = _styled.styled.h1.withConfig({
  componentId: "m4whf0-0"
})(["color:white;display:inline-block;vertical-align:middle;font-size:26px;margin:0 0 0 12px;font-family:Work Sans,Arial,sans-serif;font-weight:500;width:200px;max-height:100%;line-height:normal;", ""], _Core.media.screenSm(_templateObject())); // @inject("firebaseStore")


var HeaderArea = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(HeaderArea, _Component);

  function HeaderArea(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = HeaderArea.prototype;

  _proto.render = function render() {
    var siteStore = this.props.siteStore;
    return _react.default.createElement(_Core.Flex, null, (0, _client.isClient)() && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Link.Link, {
      to: siteStore.siteHomeUrl
    }, _react.default.createElement(SiteTitle, null, siteStore.siteDisplayName)), _react.default.createElement(_Core.Box, {
      pl: 3,
      width: 1
    }, _react.default.createElement(_menu.default, {
      key: "primaryMenu",
      mode: "horizontal",
      theme: "dark"
    }, _react.default.createElement(SubMenu, {
      title: "Packing",
      key: "packingMenu"
    }, _react.default.createElement(_menu.default.Item, {
      key: "itemsByCategory"
    }, _react.default.createElement(_Link.Link, {
      to: "/packing/category/"
    }, "Items by Category")), _react.default.createElement(_menu.default.Item, {
      key: "itemsByAspect"
    }, _react.default.createElement(_Link.Link, {
      to: "/packing/plan-for/"
    }, "Items by Aspect"))), _react.default.createElement(SubMenu, {
      title: "Trip",
      key: "tripMenu"
    }, _react.default.createElement(_menu.default.Item, {
      key: "preTravelChecklist"
    }, _react.default.createElement(_Link.Link, {
      to: "/trip/pre-travel-checklist/"
    }, "Pre-Travel Checklist")), _react.default.createElement(_menu.default.Item, {
      key: "tripPlanner"
    }, _react.default.createElement(_Link.Link, {
      to: "/trip/planner/"
    }, "Trip Planner"))), _react.default.createElement(_menu.default.Item, {
      key: "posts"
    }, _react.default.createElement(_Link.Link, {
      key: "postsLink",
      to: "/posts/"
    }, "Posts"))))));
  };

  return HeaderArea;
}(_react.Component)) || _class;

exports.HeaderArea = HeaderArea;